import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Flame, Target, Trophy, Star, Users } from 'lucide-react';

export default function Challenges() {
  const [items, setItems] = useState([]);
  const [board, setBoard] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get('/challenges').then(r => setItems(r.data)); }, []);
  const openBoard = async (c) => {
    const { data } = await api.get(`/challenges/${c.id}/leaderboard`);
    setBoard(data); setOpen(true);
  };
  const metricLabels = {
    exercises_completed:'ejercicios resueltos',
    lessons_completed:'lecciones completadas',
    points_earned:'puntos ganados'
  };
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Desafíos semanales" subtitle="Metas nuevas cada lunes. Bonus por completarlas."/>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 p-12 text-center text-sm text-slate-500">
          <Target className="w-8 h-8 mx-auto mb-2 text-slate-400"/>
          No hay desafíos activos ahora. Vuelve el lunes.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-6">
          {items.map(c => {
            const progress = c.progress || 0;
            const pct = Math.min(100, (progress / c.target_value) * 100);
            const done = progress >= c.target_value;
            return (
              <div key={c.id} data-testid={`challenge-${c.id}`}
                className={`rounded-2xl bg-white p-6 border transition-all ${done ? 'border-emerald-300 bg-emerald-50' : 'border-slate-200'}`}>
                <div className="flex items-start justify-between mb-3">
                  <div className={`w-11 h-11 rounded-2xl grid place-items-center ${done ? 'bg-emerald-500' : 'bg-amber-500'} text-white`}>
                    {done ? <Trophy className="w-5 h-5"/> : <Flame className="w-5 h-5"/>}
                  </div>
                  <div className="text-right">
                    <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Bonus</div>
                    <div className="font-display font-extrabold text-amber-600 text-xl">+{c.bonus_points}</div>
                  </div>
                </div>
                <div className="font-display font-bold text-lg">{c.title}</div>
                <div className="text-sm text-slate-500 mt-1">{c.description}</div>
                <div className="mt-4">
                  <div className="flex items-center justify-between text-xs font-mono mb-1">
                    <span>{progress} / {c.target_value} {metricLabels[c.target_metric]}</span>
                    <span className="text-slate-500">{Math.floor(pct)}%</span>
                  </div>
                  <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full transition-all ${done ? 'bg-emerald-500' : 'bg-amber-500'}`} style={{width:`${pct}%`}}/>
                  </div>
                </div>
                <button data-testid={`leaderboard-${c.id}`} onClick={()=>openBoard(c)}
                  className="mt-4 text-sm text-blue-600 font-semibold inline-flex items-center gap-1 hover:underline">
                  <Users className="w-4 h-4"/> Ver ranking
                </button>
              </div>
            );
          })}
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>Ranking · {board?.challenge?.title}</DialogTitle></DialogHeader>
          {board && (
            <div className="divide-y">
              {board.leaderboard.map((r,i) => (
                <div key={r.student_id} className="py-2 flex items-center justify-between text-sm">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-full grid place-items-center font-bold text-white ${i===0?'bg-amber-500':i===1?'bg-slate-400':i===2?'bg-orange-500':'bg-slate-300'}`}>{i+1}</div>
                    <span className="font-semibold">{r.name}</span>
                  </div>
                  <span className="font-mono">{r.progress}/{r.target}</span>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
